import React, { useEffect, useState } from 'react';
import {
  Button,
  Col,
  Container,
  FloatingLabel,
  Form,
  InputGroup,
  Modal,
  Row,
  Table,
} from 'react-bootstrap';
import { AppPagination, Loading } from '../../components';
import { IProfileShort } from '../../core/models';
import { ProfilesService } from '../../services/Profiles';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { UserService } from '../../services';
const NewProfilesPage = () => {
  const navigate = useNavigate();
  const [profiles, setProfiles] = useState<IProfileShort[]>([]);
  const [loading, setLoading] = useState<Boolean>(false);
  const [pagination, setPagination] = useState({
    cur: 1,
    max: 1,
  });
  const [searchKey, setSearchKey] = useState('');
  const [approve, setApprove] = useState({
    show: false,
    file: '',
    error: false,
    id: -1,
  });
  const getProfiles = async (page: number = 1) => {
    setLoading(true);
    try {
      const res = await ProfilesService.getNewProfiles(page);
      if (res.data?.length > 0) {
        setProfiles(res.data);
        setPagination({
          cur: res.pagination_data.page,
          max: res.pagination_data.pages,
        });
      } else {
        setProfiles([]);
        setPagination({
          cur: 1,
          max: 1,
        });
      }
      setLoading(false);
    } catch (error) {
      alert(error.message);
      setLoading(false);
    }
  };
  const openProfile = (id: Number) => {
    navigate(`/dashboard/profile/${id}`);
  };
  const disableProfile = async (id: number) => {
    try {
      const val = window.confirm('Do you want to disable profile ?');
      if (val) {
        const res = await ProfilesService.disableProfile(id);
        if (res.status === 200) {
          alert('Profile disabled successfully');
          getProfiles(pagination.cur);
        } else {
          alert('Error while enabling profile');
        }
      }
    } catch (error) {
      alert(error.message);
    }
  };
  const searchProfile = async (page: number = 1) => {
    setLoading(true);
    try {
      const res = await ProfilesService.searchNewProfiles(searchKey, page);
      if (res.data?.length > 0) {
        setProfiles(res.data);
        setPagination({
          cur: res.pagination_data.page,
          max: res.pagination_data.pages,
        });
      } else {
        setProfiles([]);
        setPagination({
          cur: 1,
          max: 1,
        });
      }
      setLoading(false);
    } catch (error) {
      alert(error.message);
      setLoading(false);
    }
  };
  const approval = async (id: number, status: number, file: string) => {
    try {
      const res = await ProfilesService.updateProfileStatus(id, status, file);
      if (res.status === 200) {
        alert('Profile Status Updated');
        getProfiles();
      } else {
        alert('Profile Status Updated');
      }
      setLoading(false);
    } catch (error) {
      alert(error.message);
      setLoading(false);
    }
  };
  const updateFile = () => {
    if (!approve.file) {
      setApprove({ ...approve, error: true });
    } else {
      approval(approve.id, 2, approve.file);
      setApprove({
        id: -1,
        error: false,
        show: false,
        file: '',
      });
    }
  };
  useEffect(() => {
    getProfiles();
  }, []);
  return (
    <>
      <Container>
        <Row>
          <Col md={12}>
            <h2 className="page-title my-2">New Profiles</h2>
          </Col>
        </Row>
        <Row className="my-3 justify-content-end">
          <Col md={4} className="text-end ">
            <InputGroup>
              <Form.Control
                placeholder="Search Name, SGS No, File No...  "
                value={searchKey}
                onChange={(e) => setSearchKey(e.target.value)}
              />
              <Button variant="primary" onClick={() => searchProfile()}>
                Search
              </Button>
              {searchKey && (
                <Button
                  variant="secondary"
                  onClick={() => {
                    setSearchKey('');
                    getProfiles();
                  }}
                >
                  {' '}
                  <FontAwesomeIcon icon={faTimes} />{' '}
                </Button>
              )}
            </InputGroup>
          </Col>
          <Col md={2} className="text-end d-grid">
            <Button onClick={() => navigate('/dashboard/add-profile')}>Add Profile</Button>
          </Col>
        </Row>
        <>
          <Row>
            <Col>
              <Table striped hover>
                <thead>
                  <tr>
                    <th>Sl.No</th>
                    <th>Name</th>
                    <th>File No.</th>
                    <th>SGS No.</th>
                    <th>Phone</th>
                    <th>Approve</th>
                    <th>Reject</th>
                    {UserService.isAdmin() && <th>Disable</th>}
                  </tr>
                </thead>
                <tbody>
                  {!loading &&
                    profiles.length > 0 &&
                    profiles.map((i, index) => (
                      <tr key={i.id} onClick={() => openProfile(i.id)}>
                        <td>{index + 1}</td>
                        <td>{i.name}</td>
                        <td>{i.fileNo}</td>
                        <td>{i.sgsNo}</td>
                        <td>{i.contactDetails.mobileNo1}</td>
                        <td>
                          <Button
                            onClick={(e) => {
                              e.stopPropagation();
                              setApprove({
                                ...approve,
                                id: i.id,
                                show: true,
                              });
                            }}
                          >
                            Approve
                          </Button>
                        </td>
                        <td>
                          <Button
                            onClick={(e) => {
                              e.stopPropagation();
                              approval(i.id, 3, i.fileNo);
                            }}
                          >
                            Reject
                          </Button>
                        </td>
                        {UserService.isAdmin() && (
                          <td>
                            <Button
                              onClick={(e) => {
                                e.stopPropagation();
                                disableProfile(i.id);
                              }}
                              variant="outline-danger"
                            >
                              Disable
                            </Button>
                          </td>
                        )}
                      </tr>
                    ))}
                </tbody>
              </Table>
            </Col>
            {loading && <Loading />}
            {!loading && profiles.length === 0 && (
              <h4 className="text-secondary text-center my-5 py-5">No Records Found</h4>
            )}
            <div className="d-flex justify-content-center my-3">
              <AppPagination
                curPage={pagination.cur}
                maxPage={pagination.max}
                changePage={(n) => (searchKey ? searchProfile(n) : getProfiles(n))}
              />
            </div>
          </Row>
        </>
        <Modal
          show={approve.show}
          onHide={() => setApprove({ show: false, file: '', id: -1, error: false })}
        >
          <Modal.Header className="bg-primary text-light" closeButton>
            <Modal.Title>Enable Profile</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <FloatingLabel label="File No." className="mb-3">
              <Form.Control
                name="file"
                placeholder="File No."
                value={approve.file}
                onChange={(e) => setApprove({ ...approve, file: e.target.value })}
                isInvalid={!!approve.error}
              />

              {approve.error && <p className="error">File No. cannot be empty</p>}
            </FloatingLabel>
            <div className="d-grid my-3">
              <Button onClick={updateFile}>Approve</Button>
            </div>
          </Modal.Body>
        </Modal>
      </Container>
    </>
  );
};
export default NewProfilesPage;
